import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=6804ffb3&scoped=true&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&id=6804ffb3&prod&scoped=true&lang=css&"
import style1 from "./Category.vue?vue&type=style&index=1&id=6804ffb3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6804ffb3",
  null
  
)

export default component.exports